import axiosInstance from '../axiosInstance';

/**
 * FAQ 페이지용: 전체 토픽 + 전체 FAQ 항목 (isActive 상관없이)
 */
export const getTopicsWithFaqs = async () => {
  try {
    const response = await axiosInstance.get('/faq/topics/all');
    return response.data.data ?? response.data;
  } catch (error) {
    console.error('Get Topics With Faqs API Error:', error);
    throw error;
  }
};

/**
 * QnA 사이드용: 전체 토픽 + 활성화된 FAQ 항목만 (isActive = true)
 */
export const getActiveTopicsWithFaqs = async () => {
  try {
    const response = await axiosInstance.get('/faq/topics/active');
    return response.data.data ?? response.data;
  } catch (error) {
    console.error('Get Active Topics With Faqs API Error:', error);
    throw error;
  }
};
